import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function ShaunJackson() {
  const shaunJacksonSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Shaun Jackson",
    "jobTitle": "Founder and Director",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/shaun-jackson"
  };

  return (
    <div className="boardOfDirectorsBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Shaun Jackson - Founder and Director"
        description="Shaun Jackson is a clinical academic and NHMRC Investigator with expertise in cardiovascular research and antithrombotic therapeutics development."
        keywords={['Shaun Jackson', 'Founder', 'Blood Clotting Research', 'Cardiovascular Research', 'NHMRC']}
        ogImage="/shaunJackson.webp"
        schema={shaunJacksonSchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/board-of-directors" className="text-white hover:text-primary-red transition-colors">
            Board of Directors
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Shaun Jackson</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Professor Shaun Jackson
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Founder and Director
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/shaunJackson.webp" 
                alt="Professor Shaun Jackson, Founder and Director: Internationally Renowned Leading Expert in Blood Clotting Research" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Shaun Jackson is a clinical academic and a National Health and Medical Research Council (NHMRC) of Australia Investigator (Leadership Level 3). He has been a faculty member at the Scripps Research Institute in La Jolla, San Diego (California, USA) since 2009 and an Honorary Visiting fellow at the University of Cambridge, UK. In 2015, he was appointed as the inaugural Director of Cardiovascular Research, at the Heart Research Institute & Charles Perkins Centre, University of Sydney. He has been the founder and director of several Australian biotechnology companies focussing on the clinical development of novel antithrombotic therapeutics.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="shaun-jackson" 
        basePath="/leadership" 
      />
    </div>
  );
}